import { Fragment, useMemo } from 'react';
import { Ingredient } from '@/types';
import { calculateMaximalUnit } from '@/utils';
import { UI } from '@/Components/UI';
import { useConfig, useLocalizedRoute } from '@/hooks';
import { useTranslation } from 'react-i18next';

type IngredientsListProps = {
    ingredients: Ingredient[];
    initialServings: number;
    servings: number;
};

export const IngredientsList = ({ ingredients, initialServings, servings }: IngredientsListProps) => {
    const { localizedRoute } = useLocalizedRoute();
    const { measuringUnits } = useConfig();
    const { t } = useTranslation(['recipes']);

    const scaledIngredients = useMemo(() => {
        return ingredients.map((ingredient) => {
            return {
                ...ingredient,
                scaledAmount: calculateMaximalUnit(
                    (ingredient.amount / initialServings) * servings,
                    ingredient.measuringUnit,
                    measuringUnits
                )
            };
        });
    }, [ingredients, initialServings, servings, measuringUnits]);

    return (
        <div className={'grid grid-cols-2 gap-2'}>
            {scaledIngredients.map((ingredient) => (
                <Fragment key={ingredient.id}>
                    <div className={'text-right'}>
                        <UI.Fraction
                            number={ingredient.scaledAmount.amount} />
                        &nbsp;
                        {t(`ingredients.units.${ingredient.scaledAmount.unit}`) ?? ingredient.scaledAmount.unit}
                    </div>
                    <div>
                        <UI.Link
                            href={localizedRoute('search.index', { food: [ingredient.food.id] })}
                            className={'text-unset'}>
                            {ingredient.food.name}
                        </UI.Link>
                    </div>
                </Fragment>
            ))}
        </div>
    );
};
